import { api } from './api';

const getOperationClaimsList = async ({body}) => {
    const response = await api({
        url: `OperationClaims/getList`,
        method: 'GET',
        params: body,
    });
    return response.data;
};

const addOperationClaims = async (data) => {
    const response = await api({
        url: `OperationClaims`,
        method: 'POST',
        data,
    });
    return response.data;
};

const updateOperationClaims = async (data) => {
    const response = await api({
        url: `OperationClaims`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const deleteOperationClaims = async ({id}) => {
    const response = await api({
        url: `OperationClaims`,
        method: 'DELETE',
        data: {
            id,
        },
    });
    return response.data;
};

const getPagedList = async ({id}) => {
    const response = await api({
        url: `OperationClaims/getPagedList?vouId=${id}`,
        method: 'GET',
    });
    return response.data;
};

const getAllClaims = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `OperationClaims/getOperationClaimForUserList?Page=${pageNumber}&PageSize=${pageSize}`,
        method: 'GET',
        params: body,
    });
    return response.data;
};

const operationClaimsServices = {
  getOperationClaimsList,
  addOperationClaims,
  deleteOperationClaims,
  updateOperationClaims,
  getPagedList,
  getAllClaims,
};

export default operationClaimsServices;
